import { useCallback, useEffect, useRef } from "react";
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from "recoil";

import { fetchResultsCallback, pollingCallback } from "./callbacks";
import { activityStreamState } from "./state";

const INITIAL_DELAY = 500;
const MAX_DELAY = 5000;

const useActivityStream = (idRecipient, channel) => {
  const key = { idRecipient, channel };

  const timer = useRef(null);
  const delay = useRef(INITIAL_DELAY);

  const { idTask, pollingIteration, ...value } = useRecoilValue(
    activityStreamState(key),
  );

  const reset = useResetRecoilState(activityStreamState(key));
  const fetch = useRecoilCallback(fetchResultsCallback, []);
  const polling = useRecoilCallback(pollingCallback, []);

  const fetchResults = useCallback(
    (pageNumber, pageSize, activityEventTypes) =>
      fetch(idRecipient, channel, pageNumber, pageSize, activityEventTypes),
    [fetch, idRecipient, channel],
  );

  const cleanup = useCallback(() => {
    clearTimeout(timer.current);
    reset();
  }, [reset]);

  useEffect(() => {
    if (idTask > 0 && pollingIteration > 0) {
      timer.current = setTimeout(polling, delay.current, idRecipient, channel);
      delay.current = Math.min(delay.current * 2, MAX_DELAY);
    }
  }, [idTask, pollingIteration, polling, idRecipient, channel]);

  return {
    value,
    fetchResults,
    cleanup,
  };
};
export default useActivityStream;
